//Generelle Seitenelemente, die immer getrackt werden sollen
var globalUsabilityClickElements = {
  '.bodytext .inline-link:not([rel*="external"])': {
    //Interner Link im Copytext
    'type': 'navigation',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Copytext',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .linkliste a:not([rel*="external"])': {
    //Interner Link in Multibox
    'type': 'navigation',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link in Multibox',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.breadcrumb a': {
    //Link in den Breadcrumbs
    'type': 'navigation',
    'click': 'Navigation via Breadcrumb zu "{INNER-TEXT}"',
    'click_chapter1': 'Breadcrumb',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#footer a:not([rel*="external"])': {
    //Interner Link im Footer
    'type': 'navigation',
    'click': 'Navigation via Link im Footer zu "{INNER-TEXT}"',
    'click_chapter1': 'Footer',
    'click_chapter3': '{ZIEL-URL}'
  },
  'form input[type=radio]' : {
    //SOS-36364: Radio-Buttons in Formularen
    'type': 'action',
    'click': '"{INPUT-VALUE}" ausgewählt',
    'click_chapter1': 'Formular',
    'click_chapter3': ''
  },
  '.form:not(.form-quiz):not(.form-voting) button[type="submit"]': {
    //Submit-Button im UGC-Formular
    'type': 'action',
    'click': 'Ein Formular wurde gesendet',
    'click_chapter1': 'CTA',
    'click_chapter3': '{ACTION-URL}'
  },
  '.form-quiz button[type="submit"]': {
    //Submit-Button im Quiz
    'type': 'action',
    'click': 'Ein Quiz wurde gesendet',
    'click_chapter1': 'CTA',
    'click_chapter3': '{ACTION-URL}'
  },
  '.form-voting button[type="submit"]': {
    //Submit-Button im Voting
    'type': 'action',
    'click': 'Ein Voting wurde gesendet',
    'click_chapter1': 'CTA',
    'click_chapter3': '{ACTION-URL}'
  },
  '.modal button[data-dismiss="modal"]': {
    //Modal-Fenster wurde geschlossen
    'type': 'action',
    'click': 'Das Modalfenster wurde geschlossen',
    'click_chapter1': 'Modal',
    'click_chapter3': '{MODAL-HEADLINE}'
  },
  '.sharing a, .sharing button': {
    //Sharebuttons
    'type': 'action',
    'click': 'Teilen via "{SHAREBUTTON-NAME}"',
    'click_chapter1': 'Share',
    'click_chapter3': ''
  },
  '.more-linking a:not([rel*="external"])': {
    //Interner Link "Mehr zum Thema"
    'type': 'navigation',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Block "Mehr"',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.detail-body .mediaplayer-download a': {
    // Downloads
    'type': 'download',
    'click': 'Download-Link mit Inhalt "<INNER-TEXT>" wurde geklickt',
    'click_chapter1': 'Download',
    'click_chapter3': '{ZIEL-URL}'
  }
};

window.localUsabilityClickElements = window.localUsabilityClickElements || {};
var usabilityClickElements = extend({}, globalUsabilityClickElements, window.localUsabilityClickElements);

/**
 * Vanilla JavaScript version of jQuery.extend()
 *
 * @param {...boolean} [deep]
 * @param {...Object} object1
 * @param {...Object} objectN
 * @returns {Object}
 */
function extend() {

  // Variables
  var extended = {};
  var deep = false;
  var i = 0;
  var length = arguments.length;

  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0];
    i++;
  }

  // Merge the object into the extended object
  var merge = function (obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  };

  // Loop through each object and conduct a merge
  for (; i < length; i++) {
    var obj = arguments[i];
    merge(obj);
  }

  return extended;

}
